<template>
  <layout ref="layout">
    <Loading
      v-if="showLoading2"
      :zIndex="3"
      :isLoading="isLoading2"
      @reload="getDataLoading"
    />
    <div ref="container">
      <van-cell-group ref="cell">
        <van-cell title="公司名称" :value="companyDetail.companyName" />
        <van-cell title="钢瓶总数" :value="companyDetail.totalNum" />
        <van-cell title="在用" :value="companyDetail.useNum" />
        <van-cell title="退出" :value="companyDetail.quitNum" />
      </van-cell-group>
      <van-row ref="row" gutter="16">
        <van-col span="12">
          <van-button
            block
            type="primary"
            native-type="button"
            to="/cylinderCrculation"
          >
            钢瓶流通管理
          </van-button>
        </van-col>
        <van-col span="12">
          <van-button
            block
            type="primary"
            native-type="button"
            to="/cylinderRisk"
          >
            钢瓶风险管理
          </van-button>
        </van-col>
      </van-row>
      <van-search
        ref="search"
        v-model="words"
        placeholder="钢瓶查询"
        input-align="center"
        @search="onSearch"
      />
    </div>
    <div class="search-content" ref="searchContent">
      <Content :top="0" :bottom="0" @content-scroll="handleContentScroll">
        <Loading v-if="showLoading" :isLoading="isLoading">
          <p>加载失败</p>
          <van-button type="primary" size="small" @click="onSearch(words)"
            >刷新</van-button
          >
        </Loading>
        <ul v-if="list.length" class="list">
          <li
            class="list-item"
            v-for="item in list"
            :key="item.gsId"
            @click="handleItemClick(item.gsCode)"
          >
            {{ item.gsCode }}
          </li>
        </ul>
        <Empty v-else description="无查询结果" />
        <loading-more
          :finished="finished"
          :showLoadingMore="showLoadingMore"
          :loadingFail="loadingFail"
          :list="list"
          @reload="getList"
        />
      </Content>
    </div>
  </layout>
</template>

<script>
import { onMounted, ref, computed } from 'vue'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { getSettleList, searchGasByCode } from '@/api/steelCylinder'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'SteelCylinder', // 钢瓶
  setup() {
    // 获取公司钢瓶信息
    const store = useStore()
    const companyId = computed(() => store.state.roleInfo.companyId)
    const companyDetail = ref({})
    const {
      getDataLoading,
      showLoading: showLoading2,
      isLoading: isLoading2
    } = useGetDataLoading(
      getSettleList,
      (data) => {
        companyDetail.value = data
      },
      { companyId: companyId.value }
    )
    getDataLoading()

    // 搜索
    const words = ref('')
    const data = useLoadingMore(searchGasByCode)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = (value) => {
      list.value = []
      pageParams.companyId = companyId.value
      pageParams.searchCode = value
      pageParams.page = 1
      pageParams.pageNum = 15
      finished.value = false
      loadingFail.value = false
      getList()
    }
    init('')
    const onSearch = (value) => {
      init(value)
    }

    // 计算搜索结果的高度
    const container = ref(null)
    const searchContent = ref(null)
    const layout = ref(null)
    window.onresize = () => {
      setSize()
    }
    onMounted(() => {
      setSize()
    })
    const setSize = () => {
      const layoutHeight = layout.value.$el.children[0].offsetHeight
      const containertHeight = container.value.offsetHeight
      searchContent.value.style.height = layoutHeight - containertHeight + 'px'
    }

    // 点击钢瓶
    const router = useRouter()
    const handleItemClick = (id) => {
      router.push(`/cylinderInfo/${id}`)
    }
    return {
      getDataLoading,
      showLoading2,
      isLoading2,
      companyDetail,
      words,
      onSearch,
      container,
      searchContent,
      layout,
      list,
      handleItemClick,
      ...data
    }
  }
}
</script>

<style lang="scss" scoped>
.van-row {
  padding: 16px;
}
.van-search {
  padding: 16px;
}
.search-content {
  position: relative;
  overflow: hidden;
}
.list {
  padding: 0 16px 16px 16px;
  font-size: 14px;
  .list-item {
    padding: 14px;
    background-color: #fff;
    box-shadow: rgba(42, 45, 51, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-top: 16px;
  }
}
</style>
